<div class="star-container">
  @for (star of starArray; track $index) {
    <div>
      <app-svg-icon name="{{ star }}"></app-svg-icon>
    </div>
  }
</div>
